var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 143,
    viewBox: "0 0 121 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3139 85.0184C67.9364 84.0194 70.1413 82.1585 71.5669 79.7413L76.2898 71.7328C82.6896 60.881 99.3204 65.4198 99.3204 78.0181V97.1506C99.3204 103.984 93.7809 109.524 86.9475 109.524H68.2229C54.4846 109.524 50.9799 90.479 63.8182 85.5882L65.3139 85.0184Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2446 68.8179C43.0669 71.6185 43.8465 74.3964 45.4555 76.6956L50.7862 84.3131C58.0095 94.635 46.986 107.889 35.5207 102.667L18.109 94.7375C11.8901 91.9053 9.14474 84.568 11.977 78.3492L19.7377 61.3086C25.4318 48.8058 44.2161 53.5097 43.346 67.2205L43.2446 68.8179Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5765 60.7134C64.3981 58.9443 61.6829 57.9684 58.8767 57.9457L49.5796 57.8705C36.9817 57.7687 32.5776 41.1017 43.4807 34.7899L60.0388 25.2044C65.9528 21.7808 73.5223 23.7997 76.9459 29.7136L86.327 45.9186C93.21 57.8084 78.4838 70.383 67.819 61.7224L66.5765 60.7134Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3d23d192689b917d8ed3f76b4bc81154.svg";
export { ForwardRef as ReactComponent };